export default __webpack_public_path__ + "static/media/School_Warm_3_2.3b125eda.png";